<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Transfer_Units_Title' | translateWF: 'Transfer Units' }}</h1>
        @if (canEdit()) {
          <div class="page__title_buttons">
            <p-button [label]="'Transfer_Units_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails()" />
          </div>
        }
      </div>
    </div>

    <p-panel>
      <p-card data-variant="compact">
        <p-tabs [(value)]="selectedTab">
          <p-tablist>
            @for (tab of statusTabs; track tab.value) {
              <p-tab [value]="tab.value">{{ tab.key | translateWF: tab.fallback }}</p-tab>
            }
          </p-tablist>

          <div class="cs-page-list-grid">
            <!-- Filters -->
            @if (filterConfig() && showFilters()) {
              <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
            }

            <!-- Data Table -->
            <p-panel [header]="'Transfer_Units_Title' | translateWF: 'Transfer Units'">
              <ng-template pTemplate="icons">
                <p-button
                  [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
                  [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
                  (click)="showFilters.set(!showFilters())"
                  variant="outlined"
                  size="small"
                />
              </ng-template>
              <p-card data-variant="compact">
                <!-- Shared table -->
                <p-table [value]="transferUnits()" selectionMode="single" class="mt-2">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>{{ 'Transfer_Units_Number' | translateWF: 'Transfer Unit Number' }}</th>
                      <th>{{ 'Transfer_Units_Knitting_Order' | translateWF: 'Knitting Order' }}</th>
                      <th>{{ 'Transfer_Units_Roll_Numbers' | translateWF: 'Roll Numbers' }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-transferUnit>
                    <tr class="cursor-pointer" (click)="redirectToDetails(transferUnit.id)">
                      <td>
                        <a>{{ transferUnit.number }}</a>
                      </td>
                      <td>{{ transferUnit?.initiatorNumber }}</td>
                      <td>{{ getRollNumbers(transferUnit) }}</td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="3">
                        {{ 'Transfer_Units_Not_Found' | translateWF: 'No Transfer Units Found' }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>

                <!-- Pagination -->
                <p-paginator
                  [rows]="pageSize"
                  [totalRecords]="totalRecords"
                  [first]="(currentPage - 1) * pageSize"
                  (onPageChange)="onPageChange($event)"
                  [rowsPerPageOptions]="[10, 25, 50, 100]"
                  class="mt-4"
                ></p-paginator>
              </p-card>
            </p-panel>
          </div>
        </p-tabs>
      </p-card>
    </p-panel>
  </div>
</main>
